import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { ICreatePublicReport } from "../IApisInterface";

export const getPublicShareReportApi = async (params: { //public report 
    heatmapId: string;
    lat: number;
    lng: number;
    businessId: string;
}) => {
    const response = await AxiosInstance.get(apiRoutes?.publicShareReport, {params})
    return response
}

export const createPublicReportApi = async (payload: ICreatePublicReport) => { //ranking checker form submit
    const response = await AxiosInstance.post(apiRoutes?.createPublicReport, payload)
    return response
}

export const getPublicReportApi = async (id: string) => { 
    const response = await AxiosInstance.post(apiRoutes?.publicReport, {id})
    return response
}

export const publicCaseReportApi = async (params: {
    id: string;
    lat: any;
    long: any;
}) => {
    const response = await AxiosInstance.get(apiRoutes?.publicCase, {params})
    return response
}

export const getPublicReviewRequestApi = async (hash: string) => {
    const response = await AxiosInstance.get(`${apiRoutes?.fetchReviewRequest}?hash=${hash}`)
    return response
}

